/**
 * Returns true if the given source should be omitted according to the filter.
 *
 * - Callback filters require a full ApiSource; an undefined source returns true and is automatically omitted.
 * - Array filters match against source.id.
 */
export function isSourceOmitted(source, filter = []) {
    if (source === undefined) {
        return true;
    }
    if (typeof filter === 'function') {
        return filter(source);
    }
    return filter.includes(source.id);
}
//# sourceMappingURL=omittedSources.js.map